import classNames from 'classnames';
import PropTypes from "prop-types";
import React from 'react';

import './styles/TagList.scss';

const TagName = ({className, children}) =>
  <span className={classNames("tag-list-name", "badge", "text-secondary", className)}>
    {children}
  </span>;

TagName.propTypes = {
  className: PropTypes.string,
}

const TagList = ({className, tagNames}) => <ul className={classNames("tag-list", className)}>
  {tagNames.map(name => <li key={name}><TagName>{name}</TagName></li>)}
</ul>;

TagList.propTypes = {
  className: PropTypes.string,
  tagNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export {TagName};
export default TagList;
